<template>
  <div>
    <v-dialog v-model="confirmar" persistent max-width="330">
      <v-card>
        <v-card-title>Anulacion</v-card-title>
        <v-card-text>Esta seguro que desea anular la práctica?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              Anular()
              confirmar = false
            "
            >Aceptar</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmar = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="!esMobile"
      v-model="impresion"
      hide-overlay
      persistent
      width="80vw"
    >
      <v-card color="headeryfooter" height="80vh">
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="impresion = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>
          <div class="resp-container">
            <iframe
              class="resp-iframe"
              :src="urlReporte"
              allowfullscreen
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <h4>
      Pendientes: {{ cantpendientes }} En Gestion:
      {{ cantgestion }} Autorizadas: {{ cantautorizadas }}
    </h4> -->
    <v-simple-table style="max-height: 60vh; overflow: auto">
      <template v-slot:default>
        <tr class="green lighten-2 py-4" v-if="!nofiltrar">
          <td></td>
          <td></td>
          <td></td>
          <td>
            <v-autocomplete
              background-color="white"
              :items="tipos"
              label=""
              v-model="filtroTipo"
              outlined
              dense
              hide-details
              item-text="descripcion"
              item-value="id"
            ></v-autocomplete>
          </td>
          <td>
            <v-autocomplete
              background-color="white"
              :items="conveniosfiltro"
              label=""
              v-model="filtroconvenio"
              outlined
              dense
              hide-details
              item-text="descripcion_convenio"
              item-value="id_convenio"
            ></v-autocomplete>
          </td>
          <td>
            <v-text-field
              background-color="white"
              dense
              hide-details
              label="#"
              v-model="filtroid_solic"
              style="max-width: 70px"
              outlined
              clearable
            >
            </v-text-field>
          </td>
          <td></td>
          <td>
            <v-text-field
              background-color="white"
              dense
              hide-details
              outlined
              label="Afiliado"
              v-model="filtroafiliado"
              clearable
            >
            </v-text-field>
          </td>
          <td>
            <v-text-field
              background-color="white"
              dense
              hide-details
              outlined
              label="Práctica"
              v-model="filtropractica"
              clearable
            >
            </v-text-field>
          </td>
          <td>
            <v-autocomplete
              background-color="white"
              :items="planesfiltro"
              label="Plan"
              v-model="filtroplan"
              outlined
              dense
              hide-details
              item-text="Descripcion_plan"
              item-value="id_plan"
            ></v-autocomplete>
          </td>
          <td></td>
          <td>
            <v-text-field
              background-color="white"
              dense
              hide-details
              outlined
              label="Efector"
              v-model="filtroefector"
              clearable
            >
            </v-text-field>
          </td>
          <td>
            <v-autocomplete
              background-color="white"
              :items="provinciasfiltro"
              label="Provincia"
              v-model="filtroprovincia"
              outlined
              dense
              hide-details
              item-text="Descripcion_provincia"
              item-value="id_provincia"
            ></v-autocomplete>
          </td>
          <td v-if="!vertodas"></td>
          <td v-if="!vertodas">
            <v-btn color="cyan lighten-2" @click="() => traerPorFiltros()">
              <v-icon> mdi-magnify </v-icon>
            </v-btn>
          </td>
          <td v-if="permisoAnular"></td>
        </tr>
        <tr class="headeryfooter white--text px-0">
          <th>Orden</th>
          <th v-if="!esAutogestion">Sel.</th>
          <th v-if="!esMobile">Internado</th>
          <th v-if="!esMobile">Tipo</th>
          <th v-if="!esMobile">Convenio</th>
          <th v-if="!esMobile">Nro.Solic</th>
          <th>fecha</th>
          <th v-if="!esAutogestion">Afiliado</th>
          <th>Practica</th>
          <th>Plan</th>
          <th>Estado</th>
          <th v-if="!esMobile">Coseguro</th>
          <th v-if="!esMobile">Prestador</th>
          <th v-if="!esMobile">Provincia</th>
          <th v-if="!esAutogestion">Tomada Por</th>
          <!-- <th v-if="esAutogestion">Motivo</th> -->
          <th v-if="!vertodas"></th>
          <th v-if="permisoAnular"></th>
        </tr>
        <tbody>
          <tr
            class="px-0"
            :class="fondo(autorizacion)"
            v-for="autorizacion in lista"
            :key="autorizacion.id_solic"
          >
            <td>
              <v-btn
                color="red"
                v-if="autorizacion.estado == 2"
                small
                @click="
                  idImprimir = autorizacion.id_solic
                  impresion = true
                "
              >
                <v-icon> mdi-download </v-icon>
              </v-btn>
            </td>
            <td v-if="!esAutogestion">
              <div style="display: flex; align-items: center">
                <v-btn
                  @click="seleccionar(autorizacion)"
                  icon
                  v-if="
                    (autorizacion.TomadaPor == IdUsuario ||
                      autorizacion.TomadaPor == 0 ||
                      vertodas) &&
                    !sololistar
                  "
                  ><v-icon>mdi-magnify</v-icon></v-btn
                >
                <v-chip v-if="autorizacion.urgente" color="green">
                  Urgente
                </v-chip>
              </div>
            </td>
            <td v-if="!esMobile">
              {{ autorizacion.internadoen }}
            </td>
            <td v-if="!esMobile">
              {{ descripcionTipo(autorizacion.tipo) }}
            </td>
            <td v-if="!esMobile">
              {{
                descripcionConvenio(
                  autorizacion.Beneficiarios.id_convenio_prestacional
                )
              }}
            </td>
            <td v-if="!esMobile">{{ autorizacion.id_solic }}</td>
            <td>{{ fecha(autorizacion.fecha) }}</td>
            <td v-if="!esAutogestion">
              {{
                autorizacion.Beneficiarios.apellido_y_nombre.substring(0, 40)
              }} 
            </td>
            <td>{{ autorizacion.baso001.des_nom.substring(0, 40) }}</td>
            <td v-if="!esAutogestion">
               {{
                autorizacion.Beneficiarios.id_plan
                  ? traerPlan(autorizacion.Beneficiarios.id_plan)
                  : 'SIN PLAN'
              }}
            </td>
            <td>
              <estado
                :solotexto="esMobile"
                :estado="autorizacion.Estados"
              ></estado>
              <div v-if="tieneProrrogasPendientes(autorizacion)">
                <h5>Prorroga pend.</h5>
              </div>
            </td>
            <td v-if="!esMobile">${{ autorizacion.coseguro }}</td>
            <td v-if="!esMobile">
              {{ autorizacion.Efector.nombreefector.substring(0, 40) }}
            </td>
            <td v-if="!esMobile">
              {{ traerProvincia(autorizacion.Efector.id_provincia) }}
            </td>
            <td v-if="!esAutogestion">
              <usuario :id_usuario="autorizacion.TomadaPor"></usuario>
            </td>
            <!-- <td v-if="esAutogestion">
              <cboMotivoEstado
                readonly
                :value="autorizacion.id_motivo"
                :id_estado="autorizacion.estado"
              ></cboMotivoEstado>
            </td> -->
            <td v-if="!vertodas">
              <v-btn
                v-if="
                  autorizacion.TomadaPor == IdUsuario ||
                  (autorizacion.TomadaPor != 0 && permisoSoltar)
                "
                x-small
                color="orange"
                @click="Soltar(autorizacion)"
              >
                Soltar
              </v-btn>
            </td>
            <td v-if="permisoAnular">
              <v-btn
                x-small
                color="red"
                @click="
                  confirmar = true
                  idpracticaanular = autorizacion.id_solic
                "
              >
                Anular
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="esMobile && impresion" style="display: none">
      <iframe class="resp-iframe" :src="urlReporte" allowfullscreen></iframe>
      <h3 v-if="esMobile">Autorización descargada en formato PDF</h3>
    </div>
  </div>
</template>

<script>
import usuario from '@/components/Usuarios/TraerNombre'
import estado from '@/components/Practica/Estado'
import cboMotivoEstado from '@/components/Motivos/Combo'
import cboConvenio from '@/components/ConveniosPrestacionales/Combo'
import { isMobile, isAndroid, isWinPhone, isIOS } from 'mobile-device-detect'
import API from '@/lib/API'
import LUM from '@/lib/LUM'
import { mapGetters, mapState, mapActions } from 'vuex'
import provincias from '../../store/modules/provincias'
export default {
  data() {
    return {
      idpracticaanular: 0,
      confirmar: false,
      impresion: false,
      idImprimir: 0,
      filtroTipo: 0,
      filtroid_solic: 0,
      filtroafiliado: '',
      filtropractica: '',
      filtroefector: '',
      filtroprovincia: -1,
      filtroconvenio: -1,
      filtroplan: -1,
      tipos: [
        { id: 0, descripcion: '--TIPO--' },
        { id: 1, descripcion: 'Practica' },
        { id: 2, descripcion: 'Con Internacion' },
        { id: 3, descripcion: 'Denuncia de Internacion' },
        { id: 4, descripcion: 'Orden De Laboratorio' },
        { id: 5, descripcion: 'Autogestion' },
        { id: 6, descripcion: 'Multiple' }
      ]
    }
  },
  components: {
    usuario,
    estado,
    cboMotivoEstado,
    cboConvenio
  },
  props: {
    items: Array,
    nofiltrar: {
      type: Boolean,
      default: false
    },
    tomar: {
      type: Boolean,
      default: false
    },
    vertodas: {
      type: Boolean,
      default: false
    },
    sololistar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('comun', ['IdUsuario']),
    ...mapState('provincias', ['Lista']),
    ...mapState('planes', { planes: 'Lista' }),
    ...mapGetters('comun', ['permisoSoltar', 'permisoAnular']),
    ...mapState('conveniosprestacionales', { convenios: 'Lista' }),
    esMobile() {
      return isMobile || isAndroid || isWinPhone || isIOS
    },
    // cantpendientes() {
    //   return this.items.filter((x) => x.estado === 1).length
    // },
    // cantautorizadas() {
    //   return this.items.filter((x) => x.estado === 2).length
    // },
    // cantgestion() {
    //   return this.items.filter((x) => x.estado === 3).length
    // },
    urlReporte() {
      let ret = ''
      if (this.esMobile) {
        ret = `https://oseiv.ddns.net/Reportes/Default.aspx?rpt=ObraSocial_Afiliaciones_V/autorizacion&id=${this.idImprimir}&pdf=1&rs:embed=true`
      } else {
        ret = `https://oseiv.ddns.net/Reportes/Default.aspx?rpt=ObraSocial_Afiliaciones_V/autorizacion&id=${this.idImprimir}&rs:embed=true`
      }
      return ret
    },
    conveniosfiltro() {
      let ret = []
      ret.push({ id_convenio: -1, descripcion_convenio: '--CONVENIO--' })
      ret = ret.concat(this.convenios)
      return ret
    },
    provinciasfiltro() {
      let ret = []
      ret.push({ id_provincia: -1, Descripcion_provincia: '--PROVINCIA--' })
      ret = ret.concat(this.Lista)
      return ret
    },
    planesfiltro() {
      let ret = []
      ret.push({ id_plan: -1, Descripcion_plan: '--PLAN--' })
      ret = ret.concat(this.planes)
      return ret
    },
    lista() {
      let l = [...this.items]
      // if (this.filtroid_solic) {
      //   l = l.filter((x) => x.id_solic == this.filtroid_solic)
      // }
      // if (this.filtroafiliado) {
      //   l = l.filter(
      //     (x) =>
      //       x.Beneficiarios.apellido_y_nombre
      //         .toUpperCase()
      //         .indexOf(this.filtroafiliado.toUpperCase()) > -1
      //   )
      // }
      // if (this.filtroTipo) {
      //   l = l.filter((x) => x.tipo == this.filtroTipo)
      // }
      // if (this.filtropractica) {
      //   l = l.filter(
      //     (x) =>
      //       x.baso001.des_nom
      //         .toUpperCase()
      //         .indexOf(this.filtropractica.toUpperCase()) > -1
      //   )
      // }
      // if (this.filtroefector) {
      //   l = l.filter(
      //     (x) =>
      //       x.Efector.nombreefector
      //         .toUpperCase()
      //         .indexOf(this.filtroefector.toUpperCase()) > -1
      //   )
      // }
      // if (this.filtroconvenio > -1) {
      //   l = l.filter(
      //     (x) => x.Beneficiarios.id_convenio_prestacional == this.filtroconvenio
      //   )
      // }
      // l.sort(LUM.dynamicSort('estado'))
      // l.sort(LUM.dynamicSort('-internadoen'))
      // l.sort(LUM.dynamicSort('-fecha'))
      return l
    },
    esAutogestion() {
      let ret = false
      if (
        this.$route.path.split('/')[1].toUpperCase() ==
        'AUTOGESTIONBENEFICIARIOS'
      ) {
        ret = true
      }
      return ret
    }
  },
  methods: {
    ...mapActions('autorizaciones', ['setFiltros']),
    traerPorFiltros() {
      this.setFiltros({
        filtroTipo: this.filtroTipo,
        filtroid_solic: this.filtroid_solic,
        filtroafiliado: this.filtroafiliado,
        filtropractica: this.filtropractica,
        filtroefector: this.filtroefector,
        filtroconvenio: this.filtroconvenio,
        filtroprovincia: this.filtroprovincia,
        filtroplan: this.filtroplan
      })
    },
    traerProvincia(id) {
      return this.Lista.find((x) => x.id_provincia == id)?.Descripcion_provincia
    },
    traerPlan(id) {
      return this.planes.find((x) => x.id_plan == id)?.Descripcion_plan
    },
    seleccionar(autorizacion) {
      console.log({ autorizacion })
      if (this.tomar) {
        if (autorizacion.TomadaPor == 0) {
          API.AutorizacionesTomadas.tomar(autorizacion.id_solic)
          //this.$tomarPractica(autorizacion.id_solic, this.IdUsuario);
          //autorizacion.TomadaPor = -1;
        }
      }
      this.$emit('input', autorizacion)
    },
    Soltar(autorizacion) {
      API.AutorizacionesTomadas.soltar(autorizacion.id_solic)
      autorizacion.TomadaPor = 0
    },
    Anular() {
      API.Autorizaciones.anular(this.idpracticaanular)
    },
    descripcionTipo(id) {
      return this.tipos.find((x) => x.id == id).descripcion
    },
    descripcionConvenio(id) {
      return (
        this.convenios.find((x) => x.id_convenio == id)?.descripcion_convenio ||
        'SIN CONVENIO'
      )
    },
    fecha(dia) {
      return LUM.dataStringToDDMMYYYY(dia)
    },
    tieneProrrogasPendientes(autorizacion) {
      let ret = false
      autorizacion.Internaciones?.Prorrogas?.find((x) => x.estado == 1)
        ? (ret = true)
        : (ret = false)

      return ret
    },
    fondo(autorizacion) {
      let ret = 'white'
      if (!this.vertodas) {
        if (
          autorizacion.TomadaPor != this.IdUsuario &&
          autorizacion.TomadaPor != 0
        ) {
          ret = 'red accent-1'
        }
        if (autorizacion.TomadaPor == this.IdUsuario) {
          ret = 'blue lighten-3'
        }
      }
      return ret
    }
  }
}
</script>

<style></style>
